import * as R from "ramda";
import React, { Component } from "react";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleModal from "../../../modules/popup/SimpleModal";
import SimpleInput from "../../../modules/SimpleInput";

class MasterParameterFilter extends Component {
  handleValueChange = (name, value) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  getFilterDataValue = (fieldName, fallbackValue = "") => {
    return !R.isNil(this.props.state.filterData) && this.props.state.filterData[fieldName]
      ? this.props.state.filterData[fieldName]
      : fallbackValue;
  };

  render() {
    return (
      <SimpleModal
        title="Filter"
        visible={this.props.state.filterVisible}
        onClickClose={this.props.onClickClose}
        content={
          <ModalContainer>
            <form onSubmit={this.props.onSubmit}>
              <SimpleInput
                id="input_text_kategori_parameter"
                name="kategoriParemeter"
                label="Kategori Parameter"
                value={this.getFilterDataValue("kategoriParemeter")}
                onChange={({ target }) => this.handleValueChange(target.name, target.value)}
              />
              <SimpleInput
                id="input_text_key"
                name="key"
                label="Key"
                value={this.getFilterDataValue("key")}
                onChange={({ target }) => this.handleValueChange(target.name, target.value)}
              />
              <SimpleInput
                id="input_text_nama_parameter"
                name="namaParameter"
                label="Nama Parameter"
                value={this.getFilterDataValue("namaParameter")}
                onChange={({ target }) => this.handleValueChange(target.name, target.value)}
              />
              <div style={{ textAlign: "center" }}>
                <SimpleButton type="button" secondary onClick={this.props.onClearFilter}>
                  Hapus
                </SimpleButton>
                <SimpleButton type="submit">Terapkan</SimpleButton>
              </div>
            </form>
          </ModalContainer>
        }
      />
    );
  }
}

export default MasterParameterFilter;
